import clsx from 'clsx';
import styles from '../../ItemPage.module.scss';
import { SectionHeading } from '../SectionHeading';

interface ItemPageSectionProps {
  children: React.ReactNode;
  id: string;
  heading?: string;
  ariaLabel?: string;
  className?: string;
}

export const ItemPageSection: React.FC<ItemPageSectionProps> = ({
  children,
  id,
  heading,
  ariaLabel,
  className,
}) => {
  const headingId = `${id}-heading`;

  return (
    <section
      className={clsx(styles.section, className)}
      id={id}
      aria-labelledby={heading ? headingId : undefined}
      aria-label={ariaLabel}
    >
      {heading && <SectionHeading id={headingId}>{heading}</SectionHeading>}
      {children}
    </section>
  );
};
